import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

type Props = {
  checkoutSettingsId?: string;
  enabled?: boolean;
};
function useFetchCheckoutSettings({checkoutSettingsId, enabled = true}: Props) {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.checkoutSettings, checkoutSettingsId],
    queryFn: () => API.housing.getCheckoutSetting(checkoutSettingsId!),
    enabled: Boolean(checkoutSettingsId && enabled),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export {useFetchCheckoutSettings};
